/**
 * GraphPage - グラフビュー画面コンポーネント
 */

import { useStore, useAllSets, useNodeCount, useConnectionCount } from '../store'

export function GraphPage() {
  const setsMap = useAllSets()
  const sets = Object.values(setsMap)
  const navigateTo = useStore(state => state.navigateTo)
  const nodeCount = useNodeCount()
  const connectionCount = useConnectionCount()

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <div className="flex items-center justify-between p-4 bg-gray-800">
        <button
          onClick={() => navigateTo('home')}
          className="p-2 hover:bg-gray-700 rounded-lg transition-colors"
        >
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
        </button>
        <h2 className="text-lg font-semibold">グラフビュー</h2>
        <div className="w-10"></div>
      </div>
      
      <div className="p-4">
        <div className="bg-gray-800 rounded-lg p-4">
          <h3 className="font-semibold mb-2">グラフ構造</h3>
          <p className="text-sm text-gray-400 mb-2">
            セット数: {sets.length}
          </p>
          <p className="text-sm text-gray-400 mb-2">
            ノード数: {nodeCount}
          </p>
          <p className="text-sm text-gray-400">
            接続数: {connectionCount}
          </p>
        </div>
        
        <div className="mt-4 text-center text-gray-500">
          <p>グラフビジュアライゼーションは次のステップで実装</p>
        </div>
      </div>
    </div>
  )
}